import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from '@app/shared/services/brand/brand.service'; 

@Component({
  selector: 'app-thankyou-page',
  standalone: true, 
  imports: [],
  templateUrl: './thankyou-page.component.html',
  styleUrl: './thankyou-page.component.scss',
})
export class ThankyouPageComponent implements OnInit {
  public numeroCaso: string = '';

  private rutaActiva = inject(ActivatedRoute);
  private enrutador = inject(Router);
  public brandService = inject(BrandService);

  ngOnInit(): void {
    this.numeroCaso = this.rutaActiva.snapshot.paramMap.get('id') || '';
  }

  volverAlInicio(): void {
    this.enrutador.navigate(['/']);
  }

  verReembolsos(): void {
    this.enrutador.navigate(['/refund/history']);
  }
}